// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import SchemaAdminSettings from 'components/admin_console/schema_admin_settings';

// No changes required to the base SchemaAdminSettings, except to inject custom props.
const CustomPluginSettings = SchemaAdminSettings;

export default CustomPluginSettings;
